<template>
  <div class="selected-site-container h-100">
    <div class="header-container">
      <div class="close-details clickable" @click="onClose()">
        <div class="x">&times;</div>
      </div>
    </div>
    <field-container title="Selected Site" :parentContainer="true">
      <div class="site-details-container">
        <field-container title="">
          <overview :mappable="selected"></overview>
        </field-container>

        <field-container title="Create Data Entry">
          <data-entry-section :mappable="selected"></data-entry-section>
        </field-container>

        <field-container title="Site Reminder Schedule">
          <site-reminder-section :mappable="selected"></site-reminder-section>
        </field-container>

        <field-container title="Site Entry History">
          <site-history-section :site="selected"></site-history-section>
        </field-container>

        <field-container title="Field Notes">
          <field-notes-section
            :fieldNotes="selected.buildFieldNotes()"
          ></field-notes-section>
        </field-container>

        <div class="header-container">
          <div class="clickable" @click="() => null">
            <div class="blue-title add-note" @click="showCommentForm()">
              Add Note
            </div>
          </div>
        </div>
        <field-container title="Site Notes">
          <site-notes-section
            :siteNotes="selected.buildSiteNotes()"
          ></site-notes-section>
        </field-container>
      </div>
    </field-container>
    <comment-form :form="commentForm"></comment-form>
  </div>
</template>

<script>
import DataEntrySection from './data-entry-section';
import FieldContainer from '../../../common/field-container';
import FieldNotesSection from './field-notes-section.vue';
import Overview from './overview';
import SiteHistorySection from './site-history-section.vue';
import SiteNotesSection from './site-notes-section.vue';
import SiteReminderSection from './site-reminder-section.vue';
import Form from '@/utils/form';
import commentForm from '@/components/forms/comments';
import CommentsService from '@/services/CommentsService';

export default {
  components: {
    DataEntrySection,
    FieldContainer,
    FieldNotesSection,
    Overview,
    SiteHistorySection,
    SiteNotesSection,
    SiteReminderSection,
    commentForm,
  },

  props: {
    selected: Object,
  },

  data() {
    const $this = this;
    return {
      commentForm: new Form(CommentsService, {
        commentableId: this.selected.id,
        commentableType: 'Site',
        successCallback: ({ body }) => {
          $this.selected.addLocalSiteNote(body);
        },
      }),
    };
  },

  computed: {
    numberOfTypes() {
      return this.mappable.typesLength;
    },
  },

  methods: {
    showCommentForm() {
      this.commentForm.showEdit({
        title: 'Add Comment',
        formId: '#comment-edit',
      });
    },
    onClose() {
      const { dispatch } = this.$store;
      dispatch('selectMappable', null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';

.flex {
  display: flex;

  & .space-between {
    justify-content: space-between;
  }
}

.selected-site-container {
  margin-top: -1.8rem;
  height: 100%;
}

.site-details-container {
  margin-right: -1rem;
  margin-top: -1rem;
  overflow-x: hidden;
  overflow-y: auto;
  height: 739px;
}

.header-container {
  display: flex;
  float: right;
  justify-content: space-between;

  & .close-details {
    margin-top: 8px;
    position: relative;
    top: -4px;
    right: 10px;
    width: 11px;
    height: 11px;

    & .x {
      color: #000000;
      font-size: 24px;
      font-weight: 300;
      position: relative;
      bottom: 13px;
      right: 0.5px;
      height: 0;
      width: 0;
    }
  }
}

.add-note {
  position: relative;
  top: 0px;
  bottom: 2px;
  right: 18px;
}

.clickable {
  cursor: pointer;
}
</style>
